import React from 'react'
import './FabTournament.css'
import tournament from '../../../public/tournament.png'
import tournament1 from '../../../public/tournament1.jpg'
import tournament2 from '../../../public/tournament2.jpg'
import tournament3 from '../../../public/tournament3.jpg'

function FabTournament() {
  return (
   <>
    <div className="fab_tournament_container">
      <h1> Tournament Eligibility</h1>
      <h3> THE DEETS:</h3>
       <img src={tournament} className="tournament_image"/>
       <div className="tournament_section">
       <div className="tournament_information">
      <p><strong>Forfeits (Big No-No):</strong> FAB’s regular season consists of 8 games. If your team plays the entire season (all 8 games) with ZERO forfeits, your team will be secured an invitation into our tournament bracket. If your team forfeits during the regular season, your team will be ineligible to participate in our tournament.</p>
      <p>At FAB, we do our best to maintain a high-quality league, forfeits are disruptive to our schedule and unfair to the opposing team. Our league prides itself on hosting serious and committed teams, therefore forfeits are taken with little tolerance. </p>
      <p><strong>Locations:</strong> Tournaments are held at all FAB locations, and may be held outside of the registered location/day/time of your regular season. Please be reminded, we do not accept time/day/location requests.
</p>
      <p><strong>Eligibility:</strong> To be eligible to play in the tournament, a player must play one regular season game (with no forfeits) and complete the PLAYER REGISTRATION FORM. Teams will be placed based on their competitive level according to their record and strength of schedule. A team can pick up a non-roster player if they need an additional player to field a team of 5 players (no bench is allowed). </p>
      <p><strong>Please Note: </strong>The league fee includes playoff entry, therefore there are no refunds if a team cannot make their tournament game.</p>
     </div>
     <img className='tournament1_image' src={tournament1} />
     <div className='tournament_image_container'>
      <img className='tournament2_image' src={tournament2} />
      <img className='tournament3_image' src={tournament3} />
      </div>
     </div>
    </div>
   </>
  )
}

export default FabTournament
